const initialState = {
    msg: "",
    closeIcon: true,
    openToast: false,
    type: "error",
    name: {},
};

const modal = (state = initialState, { type, payload }) => {
    switch (type) {
        case "TOGGLE_MODAL":
            return {
                ...state,
                name: {
                    ...state.name,
                    [payload.name]: payload.state,
                },
            };
        case "TOGGLE_TOAST":
            return {
                ...state,
                msg: payload.msg,
                openToast: payload.state,
                closeIcon: payload.closeIcon,
                autoHide:payload.autoHide,
                type: payload.type,
            };
        default:
            return state;
    }
};

export default modal;
